'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useTheme } from '@/app/_lib/providers/ThemeProvider';
import LogoSvg from './LogoSvg';
interface ThemeAwareLogoProps {
  className?: string;
}

// Inner component with theme context
function ThemeAwareLogoInner(t0) {
  const $ = _c(7);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    resolvedTheme
  } = useTheme();
  const [, setForceUpdate] = useState(0);
  let t2;
  if ($[0] !== setForceUpdate) {
    t2 = () => {
      setForceUpdate(_temp);
    };
    $[0] = setForceUpdate;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== resolvedTheme) {
    t3 = [resolvedTheme];
    $[2] = resolvedTheme;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let logoColorMode;
  if (resolvedTheme === "dark") {
    logoColorMode = "light";
  } else {
    logoColorMode = "dark";
  }
  let t4;
  if ($[4] !== className || $[5] !== logoColorMode) {
    t4 = <LogoSvg colorMode={logoColorMode} className={className} />;
    $[4] = className;
    $[5] = logoColorMode;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}

// Export the inner component directly
function _temp(prev) {
  return prev + 1;
}
export function ThemeAwareLogo(props) {
  const $ = _c(7);
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!mounted) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        height: "100%",
        width: "100%"
      };
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== props.className) {
      t3 = <div className={props.className} style={t2} />;
      $[3] = props.className;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t2;
  if ($[5] !== props) {
    t2 = <ThemeAwareLogoInner {...props} />;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}